import React from 'react';
import { connect } from 'react-redux';

export const TextElementHeaderLabel = (props) => {
    const { textElementValue } = props;
   
    return (
        textElementValue.length < 1 ? <>&#x200b;</> : textElementValue
    );
};

const mapStateToProps = (state, ownProps) => {
    // Bind the component to an item from list in order to render it separately
    const textElement = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const { text: textElementValue } = textElement;

    return { textElementValue };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TextElementHeaderLabel);